import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { ScoreValue } from '../models/score-value';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReportService } from '../services/report.service';
import { ScoreService } from '../services/score.service';

@Component({
    selector: 'app-score-value',
    templateUrl: './score-value.component.html',
    styleUrls: ['./score-value.component.css'],
    standalone: false
})
export class ScoreValueComponent implements OnInit {

  @Input() itemId: string;
  //scoreValueDoc: AngularFirestoreDocument<ScoreValue>;
  scoreValue$ : Observable<ScoreValue>;

  value: string;
  constructor(
    private route: ActivatedRoute,
    //private db: AngularFirestore,
    private scoreService: ScoreService,
    private matSnackBar: MatSnackBar) {
    this.value = "";
  }

  async ngOnInit() {
    await this.loadValue();
  }

  async saveValue() {

    let studentId = this.route.snapshot.params['studentId'];

    await this.scoreService.createOrUpdateAsync(this.itemId, studentId, this.value);
    this.matSnackBar.open('Se grabó con éxito', "Close", {
        verticalPosition: "bottom",
        duration: 1000,
      });

    //Versión anterior a Firestore Modular
    // this.db.collection<ScoreValue>('scoreValues').doc(this.itemId + '-' + studentId).set({
    //   itemId: this.itemId,
    //   studentId: studentId,
    //   value: this.value
    // })
    // .then(a => {
    //   console.log('then', a);

    //   this.matSnackBar.open('Se grabó con éxito', "Close", {
    //     verticalPosition: "bottom",
    //     duration: 1000,
    //   });
    // })
    // .catch(err => {
    //   console.log('err', err);
    // });
  }

  async loadValue()
  {
    let studentId = this.route.snapshot.params['studentId'];
    this.value = (await this.scoreService.readAsync(this.itemId, studentId)).value;

    //Versión anterior a Firestore Modular
    // this.scoreValueDoc = this.db.doc<ScoreValue>('scoreValues/' + this.itemId + '-' + studentId);

    // this.scoreValueDoc.valueChanges()
    // .subscribe(a => {
    //   if (a != null)
    //     this.value = a.value;
    // });
  }
}
